import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SelectMixin } from '../../mixins/components/SelectMixin';
import { INPUT_SIZES } from '../../constants/INPUT';
import FormControl from '../../js/FormControl';
/**
 * A basic [HTML select element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select)
 * where you provide your on `option` children. You can also generate options from a data set using
 * the [`DataSelect`](#/Form%20components?id=dataselect) component.
 */

var Select = /*#__PURE__*/styled(FormControl).withConfig({
  displayName: "Select",
  componentId: "c11n-8-64-0__sc-1p9r1r3-0"
})(["", ""], SelectMixin);
Select.displayName = 'Select';
Select.propTypes = {
  /**
   * `<option>` and `<optgroup>` nodes
   */
  children: PropTypes.node.isRequired,

  /**
   * Set the select as disabled.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  disabled: PropTypes.bool,

  /**
   * Signals that there is an error with the value and sets the
   * [aria-invalid](https://www.w3.org/TR/wai-aria/#aria-invalid) property.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  error: PropTypes.bool,

  /**
   * Selects are fluid by default, taking up all horizontal space. For auto sizing,
   * set this to false.
   */
  fluid: PropTypes.bool,

  /**
   * Set the size of the select.
   */
  size: PropTypes.oneOf(Object.keys(INPUT_SIZES)),

  /**
   * Mark the select as required with the native [`required`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/required)
   * attribute.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  required: PropTypes.bool,

  /**
   * styled-components forwarded `as` component.
   * @ignore
   */
  forwardedAs: PropTypes.string
};
Select.defaultProps = {
  fluid: true,
  size: INPUT_SIZES.md,
  forwardedAs: 'select'
};
/** @component */

export default Select;
export var StyledSelect = Select;